export const getNoteHistoryStatus = (state, noteId) =>
  state.notesHistory.status.get(noteId)

export const getNoteHistory = (state, noteId) =>
  state.notesHistory.map.get(noteId)
